import axios from "axios";
import { useEffect, useState } from "react";

export default function Disclaimer() {
    const [content, setContent] = useState("");

    const getData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/disclaimer/1`
            );

            if (res.status === 200 && res.data.data) {
                setContent(res.data.data.description);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <div
            style={{
                minHeight: "100vh",
                background:
                    "linear-gradient(135deg, rgb(240 253 253) 0%, rgba(155, 222, 218, 0.73) 50%, rgb(3 186 187) 100%)",
                display: "flex",
                justifyContent: "center",
                padding: "50px 10px",
                boxSizing: "border-box",
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
                    width: "100%",
                    maxWidth: "1100px",
                    padding: "30px",
                    boxSizing: "border-box",
                }}
            >

                <h2 className="mb-4" style={{
                    fontSize: '2rem',
                    fontWeight: 700,
                    color: '#1bafb4',
                    textAlign: 'center',
                    marginBottom: '16px'
                }}>Disclaimer</h2>

                {/* Print HTML content from database */}
                <div
                    dangerouslySetInnerHTML={{ __html: content }}
                    style={{ lineHeight: "1.7", fontSize: "16px" }}
                ></div>
            </div>
        </div>
    );
}
